const Works = {
  Y2025: {
    EKS_DEMO_TERRAFORM: {
      name: '2025_EKS_DEMO_TERRAFORM',
      thumbnail: '/images/works/2025/eks-demo-terraform/logo.png'
    },
    BLITZHYPE: {
      name: '2025_BLITZHYPE',
      thumbnail: '/images/works/2025/blitzhype/logo.png'
    },
  },
  Y2024: {
    EKS_DEMO: {
      name: '2024_EKS_DEMO',
      thumbnail: '/images/works/2024/eks-demo/logo.png'
    },
    GOD: {
      name: '2024_GOD',
      thumbnail: '/images/works/2024/god/logo.png'
    },
    MEZZYA: {
      name: '2024_Mezzya',
      thumbnail: '/images/works/2024/mezzya/logo.png'
    },
    BREEEDS: {
      name: '2024_Breeeds',
      thumbnail: '/images/works/2024/breeeds/logo.png'
    },
    ANYJOI: {
      name: '2024_Anyjoi',
      thumbnail: '/images/works/2024/anyjoi/logo.png'
    },
    STUDENTSPACE: {
      name: '2024_StudentSpace',
      thumbnail: '/images/works/2024/studentspace/logo.png'
    }
  },
  Y2022: {
    SUPERJOI: {
      name: '2022_Superjoi',
      thumbnail: '/images/works/2022/superjoi/logo.png'
    }
  },
  Y2020: {
    EDUTECH: {
      name: '2020_Edutech',
      thumbnail: '/images/works/2020/edutech/logo.png'
    }
  }
}

export default Works
